import { render } from "./FormSections.vue?vue&type=template&id=7b07b25c&scoped=true&ts=true"
import script from "./FormSections.vue?vue&type=script&lang=ts"
export * from "./FormSections.vue?vue&type=script&lang=ts"

import "./FormSections.vue?vue&type=style&index=0&id=7b07b25c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b07b25c"]])

export default __exports__